import { useTranslation } from 'react-i18next'
import { useNavigation } from '@/contexts/NavigationContext'
import { cn } from '@/lib/cn'
import { NavIcon } from './NavIcon'
import { PRIMARY_NAV } from './nav-items'

/**
 * Mobile bottom navigation bar with safe-area padding for notched devices.
 */
export function BottomNav({ className }: { className?: string }) {
  const { t } = useTranslation('common')
  const { route, setRoute, openDrawer } = useNavigation()

  return (
    <nav
      className={cn(
        'fixed inset-x-0 bottom-0 z-bottomnav',
        'border-t border-terminal-border/50 bg-terminal-bg/95 backdrop-blur-md',
        'pb-[max(0.35rem,env(safe-area-inset-bottom))]',
        className,
      )}
      aria-label="Mobile primary"
    >
      <ul className="grid grid-cols-5">
        {PRIMARY_NAV.map((item) => {
          const active = route === item.id
          return (
            <li key={item.id}>
              <button
                type="button"
                onClick={() => setRoute(item.id)}
                className={cn(
                  'flex w-full flex-col items-center gap-0.5 px-1 py-2 text-[10px] font-medium',
                  'min-h-touch transition-colors',
                  active ? 'text-accent' : 'text-terminal-muted',
                )}
                aria-current={active ? 'page' : undefined}
              >
                <NavIcon name={item.icon} className="h-5 w-5" />
                <span className="truncate">{t(item.labelKey)}</span>
              </button>
            </li>
          )
        })}
        <li>
          <button
            type="button"
            onClick={openDrawer}
            className={cn(
              'flex w-full flex-col items-center gap-0.5 px-1 py-2 text-[10px] font-medium',
              'min-h-touch text-terminal-muted transition-colors',
            )}
            aria-label={t('nav.more')}
          >
            <MoreIcon className="h-5 w-5" />
            <span>{t('nav.more')}</span>
          </button>
        </li>
      </ul>
    </nav>
  )
}

function MoreIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <circle cx="5" cy="12" r="1.75" />
      <circle cx="12" cy="12" r="1.75" />
      <circle cx="19" cy="12" r="1.75" />
    </svg>
  )
}
